export default __webpack_public_path__ + "static/media/smiley_rating_poor.aac626d6.svg";